import { render, staticRenderFns } from "./AboutTeamVision.vue?vue&type=template&id=764dd80c&scoped=true"
import script from "./AboutTeamVision.vue?vue&type=script&lang=js"
export * from "./AboutTeamVision.vue?vue&type=script&lang=js"
import style0 from "./AboutTeamVision.vue?vue&type=style&index=0&id=764dd80c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764dd80c",
  null
  
)

export default component.exports